import { render, staticRenderFns } from "./rlmate.vue?vue&type=template&id=6291f8ac&scoped=true"
import script from "./rlmate.vue?vue&type=script&lang=js"
export * from "./rlmate.vue?vue&type=script&lang=js"
import style0 from "./rlmate.vue?vue&type=style&index=0&id=6291f8ac&prod&lang=scss"
import style1 from "./rlmate.vue?vue&type=style&index=1&id=6291f8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6291f8ac",
  null
  
)

export default component.exports